/**
 * Application configuration and feature flags
 */

/**
 * Feature flags for enabling/disabling functionality
 */
export const FEATURE_FLAGS = {
  /**
   * Default version (v1-only)
   */
  DEFAULT_VERSION: 'v1' as const
} as const

/**
 * API configuration
 */
export const API_CONFIG = {
  /**
   * v1 API base path
   */
  BASE: '/v1',

  /**
   * Base API URL (can be overridden via environment variable)
   */
  BASE_URL: import.meta.env.VITE_API_URL || ''
} as const

/**
 * Application metadata
 */
export const APP_CONFIG = {
  NAME: 'SAIF Admin',
  VERSION: '1.0.0',
  MODE: 'v1-only (lean)'
} as const
